type NotificationOptions = {
  // biome-ignore lint/style/useNamingConvention: existing error
  email_new_comments: boolean;
  // biome-ignore lint/style/useNamingConvention: existing error
  email_new_rsvp: boolean;
  // biome-ignore lint/style/useNamingConvention: existing error
  notify_only_my_activity: boolean;
  // biome-ignore lint/style/useNamingConvention: existing error
  push_new_comments: boolean;
  // biome-ignore lint/style/useNamingConvention: existing error
  push_new_rsvp: boolean;
  // biome-ignore lint/style/useNamingConvention: existing error
  notify_only_my_activity_push: boolean;
};

export type Payload = {
  name: string;
  email?: string;
  phone: string;
  response: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  adults_in_party: number;
  // biome-ignore lint/style/useNamingConvention: existing error
  kids_in_party: number;
  comments: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  guest_id?: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  vendor_optin?: string[];
  optin?: boolean;
  // biome-ignore lint/style/useNamingConvention: existing error
  notification_options?: NotificationOptions;
};

export enum RsvpStatuses {
  Yes = 'Yes',
  Maybe = 'Maybe',
  No = 'No',
}
